/**
 * Taking up a session that was handed to this tab after it had already
 * started.
 *
 * Reported 2026-07-26: after pairing, the phone had real tokens and loaded
 * real data, and the app still showed nobody signed in. Both were true. The
 * axios interceptor reads the token out of storage on every request, so
 * anything fetched after pairing was properly authenticated. But the auth
 * context asks who you are once, in a mount effect, and pairing finished with
 * a client-side route change, so nothing ever asked again.
 *
 * A full load rather than a re-fetch. It is one line instead of a second way
 * of becoming signed in, and it starts the app in exactly the state it would
 * have been in had the tokens been there all along, service worker and all.
 */
export function adoptSession(tokens, { storage = window.localStorage, location = window.location } = {}) {
  if (!tokens || !tokens.access_token) {
    throw new Error("A session needs at least an access token.");
  }
  storage.setItem("access_token", tokens.access_token);
  if (tokens.refresh_token) storage.setItem("refresh_token", tokens.refresh_token);
  // replace, not assign: the pairing url carries a one-use secret in its
  // fragment and does not belong in the back button.
  location.replace("/");
}
